/**
 * VISTOERA_PLATFORM_ADMIN_MARKETING_ANALYTICS_HOME_AND_TRACKING_FOUNDATION_V1
 * — shared horizontal-bar breakdown list (task spec §16/§36/§38: Traffic
 * Sources, Device Type, New vs Returning). Same "no charting library"
 * precedent as every other chart component in this codebase — a plain
 * `<div>` bar per row, proportional to the row's own share of the total.
 */
import { platformColors } from './theme'

export interface BarListRow {
  key: string
  label: string
  value: number
  color?: string
}

export default function MarketingBarList({ rows, emptyLabel, total }: { rows: BarListRow[]; emptyLabel: string; total?: number }) {
  const sum = total ?? rows.reduce((acc, r) => acc + r.value, 0)
  if (rows.length === 0 || sum <= 0) {
    return (
      <div style={{ padding: '24px 0', textAlign: 'center', color: platformColors.mutedText, fontSize: 13 }}>{emptyLabel}</div>
    )
  }
  const palette = [platformColors.primary, platformColors.info, platformColors.success, platformColors.warning, platformColors.danger]

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      {rows.map((row, i) => {
        const pct = sum > 0 ? (row.value / sum) * 100 : 0
        const color = row.color ?? palette[i % palette.length]
        return (
          <div key={row.key}>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, marginBottom: 3 }}>
              <span style={{ color: platformColors.secondaryText, display: 'flex', alignItems: 'center', gap: 6 }}>
                <span style={{ width: 8, height: 8, borderRadius: 2, background: color, display: 'inline-block' }} />
                {row.label}
              </span>
              <span style={{ color: platformColors.primaryText, fontWeight: 600 }}>
                {row.value.toLocaleString()} · {pct.toFixed(1)}%
              </span>
            </div>
            <div style={{ height: 6, borderRadius: 3, background: 'var(--pf-neutral-bg)', overflow: 'hidden' }}>
              <div style={{ height: '100%', width: `${pct}%`, background: color, borderRadius: 3, transition: 'width 0.3s ease' }} />
            </div>
          </div>
        )
      })}
    </div>
  )
}
